export enum ChipsetType {
  choice = 'choice',
  filter = 'filter',
  input = 'input',
  group = 'group'
  // action = 'action' // todo - in future action chips will be useful
}

export interface ChipsetDataItem {
  label: string;
  value: any;
}
